import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HomeComponent } from '../../home/home.component';
import { menuOptions } from 'src/data/menu-options.data';
@Component({
    selector: 'spe-nova-ocorrencia',
    templateUrl: './nova-ocorrencia.component.html',
    styleUrls: ['./nova-ocorrencia.component.scss'],
    standalone: false
})
export class NovaOcorrenciaComponent implements OnInit {
  iFrameUrl: string = environment.urlOcorrecias + '/aberturaOcorrencia/primeiraFase.xhtml';
  idCliente: string = localStorage.getItem('idCliente') ?? '';
  idParceria: string = localStorage.getItem('idParceria') ?? '';
  idUsuario: string = '163';
  idNegocioSistema = 2;

  constructor(private homeComponent: HomeComponent) {}

  ngOnInit(): void {
    this.homeComponent.setNewVariables(
      'Nova ocorrência',
      'Selecione o contato (será o responsável pela ocorrência).',
      'ocorrencias'
    );
    this.homeComponent.idleMenuContent = menuOptions[4].content;
    this.homeComponent.iconPath = 'assets/images/64_icon_id_cards.png';
    this.makeUrl();
  }

  makeUrl() {
    let params: string = `?idUsuario=${this.idUsuario}&idNegocioSistema=${this.idNegocioSistema}&idCliente=${this.idCliente}&idGerenciamentoOcorrencia=1&idParceria=${this.idParceria}`;
    this.iFrameUrl = this.iFrameUrl + params;
  }
}
